import { render, staticRenderFns } from "./SelectedCourseBox.vue?vue&type=template&id=361db344"
import script from "./SelectedCourseBox.vue?vue&type=script&lang=js"
export * from "./SelectedCourseBox.vue?vue&type=script&lang=js"
import style0 from "./SelectedCourseBox.vue?vue&type=style&index=0&id=361db344&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports